
<div class="mt-24">
  <div class="flex flex-col items-center">
    <h1 class="heading-2 centered mb-16">Set an hourly rate</h1>

    <p class="body-1 centered mb-16 md:w-320">
      Sitters respond best to jobs with rates
      <span class="block md:inline">that are competitive in your area.</span>
    </p>

    <Pill v-if="averagePayRate > 0" class="w-max mb-24" color="green"
      >Parents near you typically pay ${{ averagePayRate }}/hr</Pill
    >
  </div>

  <Card class="block w-full md:w-368 md:h-212 mx-auto">
    <div v-if="retrievingRate" class="h-full flex justify-center items-center">
      <LoadingSpinner />
    </div>
    <form v-else>
      <div class="centered mb-36 heading-5 pt-24">
        <span id="pay-rate-range">{{ `$${sliderValue[0]}-${sliderValue[1]}/hr` }}</span>
      </div>
      <div class="mx-16 md:mx-24 mb-56">
        <slider :key="renderSliderKey" v-model="sliderValue" :min="10" :max="50" prefix="$" suffix=" per hour" />
      </div>
      <div class="flex flex-row-reverse">
        <RouteStepperNextButton :stepData="reviewSection" :draftData="draftData" />
      </div>
    </form>
  </Card>
</div>
